import { GraphQLClient } from 'graphql-request';

const X_BLOCKS_KEY = import.meta.env.VITE_OS_BLOCKS_X_BLOCKS_KEY || '';
const baseUrl = (import.meta.env.VITE_OS_BLOCKS_API_URL || '').replace(/\/$/, '');
const GRAPHQL_BASE_URL = `${baseUrl}/data/v4/gateway`;

export const abortController = new AbortController();

export interface ExtendedGraphQLClient extends GraphQLClient {
  query<T = any>(options: { query: any; variables?: any }): Promise<T>;
  mutate<T = any>(options: { query: any; variables?: any }): Promise<T>;
}

const client = new GraphQLClient(GRAPHQL_BASE_URL, {
  signal: abortController.signal,
  credentials: 'include',
  headers: {
    'x-blocks-key': X_BLOCKS_KEY,
  },
}) as ExtendedGraphQLClient;

client.query = function <T = any>(options: { query: any; variables?: any }): Promise<T> {
  return client.request<T>(options.query, options.variables);
};

client.mutate = function <T = any>(options: { query: any; variables?: any }): Promise<T> {
  return client.request<T>(options.query, options.variables);
};

export const graphqlClient = client;

export default graphqlClient;
